import { getStorageImageUrl, STORAGE_BUCKETS } from "./storage";

/** 画像URLの状態を管理するインターフェース */
interface ImageUrlState {
    [key: string]: string;
}

/** 画像の読み込み状態を管理するインターフェース */
interface LoadingState {
    [key: string]: boolean;
}

/** 画像の読み込み状態を更新する関数の型 */
type SetLoadingState = (
    state: LoadingState | ((prev: LoadingState) => LoadingState),
) => void;

/**
 * バケットから直接リサイズ済みの画像を取得する
 * @param id - 画像のID
 * @param storagePath - ストレージのパス
 * @param isFullSize - フルサイズの画像を取得するかどうか（falseの場合はサムネイル）
 * @param loadingImages - 画像の読み込み状態を管理するオブジェクト
 * @param setLoadingImages - 画像の読み込み状態を更新する関数
 * @param urls - 既に取得済みの画像URLを管理するオブジェクト
 * @returns 画像のURL、エラー時はnull
 */
export const fetchImageFromBucket = async (
    id: string,
    storagePath: string,
    isFullSize: boolean = false,
    loadingImages: LoadingState,
    setLoadingImages: SetLoadingState,
    urls: ImageUrlState,
): Promise<string | null> => {
    // 既に読み込み中または読み込み済みの場合はスキップ
    if (loadingImages[id] || urls[id]) return null;

    try {
        setLoadingImages((prev: LoadingState): LoadingState => ({
            ...prev,
            [id]: true,
        }));

        // storage_pathのフォルダ名を変更
        const adjustedPath = storagePath.replace(/^seasonal\//, "works/");

        // バケット名を決定
        const bucket = isFullSize
            ? STORAGE_BUCKETS.FEATURES
            : STORAGE_BUCKETS.THUMBNAILS;

        // リサイズオプションを設定（サムネイルの場合のみ）
        const options = isFullSize
            ? {}
            : { width: 320, height: 320, quality: 80 };

        const url = await getStorageImageUrl(bucket, adjustedPath, options);
        return url;
    } catch (error) {
        console.error("Error fetching image from bucket:", error);
        return null;
    } finally {
        setLoadingImages((prev: LoadingState): LoadingState => ({
            ...prev,
            [id]: false,
        }));
    }
};
